import { render } from "./MoaAndAgreementDataTable.vue?vue&type=template&id=7766a19f&scoped=true"
import script from "./MoaAndAgreementDataTable.vue?vue&type=script&lang=js"
export * from "./MoaAndAgreementDataTable.vue?vue&type=script&lang=js"

import "./MoaAndAgreementDataTable.vue?vue&type=style&index=0&id=7766a19f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7766a19f"]])

export default __exports__